import OnlyHeader from "components/Headers/OnlyHeader";
import React, { useState } from "react";
import {
  Container,
  Button,
  Row,
  Col,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import AdExchangeImg from "../assets/img/custom/adExchange.png";
import schoolAd from "../assets/img/custom/adForSchool.png";
import partnerAd from "../assets/img/custom/partnerAd.png";
import adPartner from "../assets/img/custom/partnerAd2.png";

const AdExchange = () => {
  const [adModal, setAdModal] = useState(false);

  const toggleAdModal = () => setAdModal(!adModal);

  return (
    <>
      <OnlyHeader />
      <Container className="mt--7">
        <h2 className="text-center">
          To update your ad Img, please contact on this email :
          fanshelpplayersadmin@gmail.com
        </h2>
        <Row>
          <Col xs="12 mt-2">
            <div className="position-relative text-center">
              <img
                src={AdExchangeImg}
                width="100%"
                className="pointer"
                alt="Ad Exchange"
              />

              <a
                href={AdExchangeImg}
                download="ad-exchange-image.jpg"
                className="btn btn-primary m-2"
              >
                Download Image
              </a>
            </div>
          </Col>
          <Col xs="12 mt-2">
            <div className="position-relative text-center">
              <img
                src={schoolAd}
                width="100%"
                className="pointer"
                alt="School Ad"
              />

              <a
                href={schoolAd}
                download="school-ad-image.jpg"
                className="btn btn-primary m-2"
              >
                Download Image
              </a>
              <a
                onClick={toggleAdModal}
                download="ad-exchange-image.jpg"
                className="btn btn-primary m-2"
              >
                Explainer Video
              </a>
            </div>
          </Col>
          <Col xs="12 mt-2">
            <div className="position-relative text-center">
              <img
                src={partnerAd}
                width="100%"
                className="pointer"
                alt="Partner Ad"
              />

              <a
                href={partnerAd}
                download="partner-ad-image.jpg"
                className="btn btn-primary m-2"
              >
                Download Image
              </a>
            </div>
          </Col>
          <Col xs="12 mt-2">
            <div className="position-relative text-center">
              <img
                src={adPartner}
                width="100%"
                className="pointer"
                alt="Ad Partner"
              />

              <a
                href={adPartner}
                download="ad-partner-image.jpg"
                className="btn btn-primary m-2"
              >
                Download Image
              </a>
            </div>
          </Col>
        </Row>
      </Container>
      <Modal isOpen={adModal} toggle={toggleAdModal} centered size="sm">
        <ModalHeader toggle={toggleAdModal}>
          How to get your wallet address
        </ModalHeader>
        <ModalBody className="text-center">
          <video width="100%" height="70%" controls>
            <source
              src="https://firebasestorage.googleapis.com/v0/b/fans-help-players.appspot.com/o/AdExchangeSchool.mp4?alt=media&token=39d15d48-9a38-42ba-b4af-4bb78c094d18"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" onClick={toggleAdModal}>
            Close
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default AdExchange;
